import { Injectable } from '@angular/core';
import { HandlerService } from '../../handlers/handlers.service';
import { MethodsService } from '../method.service';
import { environment as params } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WPService extends MethodsService {
  constructor(_HandlerService: HandlerService, http: HttpClient) {
    super(_HandlerService, http);
    this.setApi((<any>params).api.wp);
  }
  getDestBus() {
    return this.get('apimj/destinos/bus');
  }
  getGeneral(type: string, param: string) {
    return this.get('apimj/' + type + '?identifier=' + param);
  }
  getPriceTravel(key){
    return this.get('apimj/pricetravel/' + key);
  }
}
